import { observable } from "mobx";
import { Type } from "class-transformer";
import VehicleResponse from "./vehicleResponse";
import ChargeChangesDuringValidityItemResponse from "./chargeChangesDuringValidityItemResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class CustomerRefundCandidateChargeDetailResponse {
  @observable
  @Type(() => VehicleResponse)
  vehicle!: VehicleResponse;

  @observable
  chargeTypeId!: string;

  @observable
  priceListItemId!: string;

  @observable
  @Type(() => Date)
  validSince!: Date;

  @observable
  @Type(() => Date)
  validUntil!: Date;

  @observable
  price!: number;

  @observable
  chargeId!: string;

  @observable
  chargeOrderId!: string;

  @observable
  @Type(() => ChargeChangesDuringValidityItemResponse)
  chargeChangesDuringValidity?: ChargeChangesDuringValidityItemResponse[];
}
